
export default[
    {
        show(row,extra){
            return row.shbj==='1'
        },
        tag:'my-btn',
        type:'detail',
        text:'详情',
        click(row,extra){
            this.$emit('detail')
            
        }
    },{
        show(row,extra){
            return row.shbj!=='1'
        },
        tag:'my-btn',
        type:'edit',
        text:'修改',
        click(row,extra){
            this.$emit('edit')
        }
    },{
        show(row,extra){
            return row.shbj!=='1'
        },
        tag:'my-btn',
        type:'del',
        text:'删除',
        click(row,extra){
            this.$post(`${this.getGetters('mngUrl')}/revision/FangAn/BiaoDuan/del.json`,{
                id:row.bdcode,
                oper:'del'
            }, (data, res) => {
                ShowMsg('删除成功','success')
                this.$emit('reload')
            });
        }
    },{
        show(row,extra){
            return row.shbj==='1'
        },
        tag:'el-button',
        type:'text',
        icon:'el-icon-document-copy',
        text:'复制标段',
        click(row,extra){
            this.$emit('copy')
        }
    },
]